import React from 'react'

interface Props {
  children: React.ReactNode
}

const Hidden: React.FC<Props> = () => {
  return null
}

export default Hidden
